import { render } from "./FileUploadIcon.vue?vue&type=template&id=4d516c58"
const script = {}
script.render = render

export default script